import { EChartsCoreOption } from 'echarts';
import {
  ChartDataResponseResult,
  ChartProps,
  DataRecordValue,
  QueryFormColumn,
  QueryFormData,
  QueryFormMetric,
  SetDataMaskHook,
} from '@superset-ui/core';
import {
  DEFAULT_LEGEND_FORM_DATA,
  EchartsLegendFormData,
} from '../../../types';

export type EchartsRPolarBarFormData = QueryFormData &
  EchartsLegendFormData & {
    groupby: QueryFormData[];
    metric?: string;
    showLabels: boolean;
    combineMetrics: boolean;
    colorScheme?: string;
    metrics: QueryFormMetric[];
    // numberFormat: string;
    // emitFilter: boolean;
};

export interface EchartsRPolarBarChartProps
  extends ChartProps<EchartsRPolarBarFormData> {
  formData: EchartsRPolarBarFormData;
  queriesData: ChartDataResponseResult[];
}

// @ts-ignore
export const DEFAULT_FORM_DATA: EchartsRPolarBarFormData = {
  ...DEFAULT_LEGEND_FORM_DATA,
  groupby: [],
  showLabels: true,
  combineMetrics: false,
//   numberFormat: 'SMART_NUMBER',
//   emitFilter: false,
};

export interface RPolarChartTransformedProps {
  formData: EchartsRPolarBarFormData;
  height: number;
  width: number;
  echartOptions: EChartsCoreOption;
  setDataMask: SetDataMaskHook;
  labelMap: Record<string, DataRecordValue[]>;
  groupby: QueryFormColumn[];
}